import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = ({ orderBy, desc, date, devices }) => {
    return {
        "data.min": date.min,
        "data.max": date.max,
        aparelhos: devices,
        ordem: orderBy,
        desc,
    };
};

export default Object.assign(
    {
        apiUrl: "/acesso",

        async list({ pagination, filters }) {
            const url = this.userUrl({
                path: `/${pagination.page}/${pagination.amountPerPage}`,
            });
            const query = buildQueryParams(filters);
            return await Vue.http.get(url, {
                params: query,
            });
        },

        async count({ filters }) {
            const url = this.userUrl({
                path: "/paginacao",
            });
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query,
            });
        },

        async csv({ filters }) {
            return Vue.http({
                url: this.userUrl({
                    path: "/lead/csv",
                }),
                method: "GET",
                responseType: "blob",
                params: buildQueryParams(filters),
            });
        },
    },
    base
);
